module.exports = __webpack_public_path__ + "img/8.cb6ad3d7.png";